/**
 * Format an API datetime (UTC ISO string) in the logged-in user's local timezone.
 * API sends UTC; this displays in the user's browser timezone (e.g. Central 6pm).
 */
export function formatInUserTime(isoString) {
  if (!isoString) return '';
  const s = typeof isoString === 'string' && !isoString.endsWith('Z') && isoString.length > 0 && !isoString.includes('+')
    ? isoString + 'Z'
    : isoString;
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return isoString;
    return d.toLocaleString(undefined, {
      dateStyle: 'short',
      timeStyle: 'short',
      hour12: true,
    });
  } catch {
    return isoString;
  }
}

/**
 * Date only in user's local timezone (for lists).
 */
export function formatDateInUserTime(isoString) {
  if (!isoString) return '';
  const s = typeof isoString === 'string' && !isoString.endsWith('Z') && isoString.length > 0 && !isoString.includes('+')
    ? isoString + 'Z'
    : isoString;
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return isoString;
    return d.toLocaleDateString(undefined, { dateStyle: 'short', hour12: false });
  } catch {
    return isoString;
  }
}
